import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/case-studies/smackback/store-bg.webp";

function ClientBrief() {
  return (
    <section
      className="clientbrief_smack p-100"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>Client Brief</h2>
            <p>
              The client came to us, at Tekrevol, with an idea to build a
              communication tool. With Smackback, the client had a sort of hazy
              understanding of how he saw the app working. After a few
              constructive sessions with our team, together, we were able to
              give his idea a more concrete shape, and that's how the journey of
              building Smackback just got initiated. Initially, the brief was
              very simple, but as went on towards actually developing the app,
              we found out that there were multiple things that we could add to
              this idea in order to make this app offer much more utility.
            </p>
            <div className="smack_img">
              <StaticImage
                src="../../../images/case-studies/smackback/clients.webp"
                alt="smackback TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={1300}
                height={356}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default ClientBrief;
